import { render } from "./dashboardInit.vue?vue&type=template&id=755f44a1"
import script from "./dashboardInit.vue?vue&type=script&lang=js"
export * from "./dashboardInit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__